import React, { Component } from "react"
import { Fade } from 'react-reveal';
import styled from 'styled-components';
import MetaTags from 'react-meta-tags';
import Loading from './../components/loading';
import Sidebar from '../components/sidebar'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Jumbotron from 'react-bootstrap/Jumbotron'
import Breadcrumb from 'react-bootstrap/Breadcrumb'
import Image from 'react-bootstrap/Image'
import Card from 'react-bootstrap/Card'
import Button from 'react-bootstrap/Button'
import Slider from "react-slick";

const ContentStyles = styled.div`
.card-body {
  height: 280px;
}
.card-body .card-title {
  height: 115px;
}
.slick-dots li button:before {
  font-size: 15px;
  top: 10px;
}
.slick-prev:before, .slick-next:before {
  color: #343a40;
}
`;

class Whyus extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      items: [],
      host: window.location.hostname
    };
  }

  componentDidMount() {
    fetch("/json/medyadanhaberler.json?v=" + process.env.REACT_APP_SITE_VERSION)
      .then(res => res.json())
      .then(
        (result) => {
          this.setState({
            isLoaded: true,
            headers: {
              "Content-Type": "application/json"
            },
            items: result
          });
        },
        // Not: Burada hataları yakalamak önemlidir.
        // Bileşenimizde bug bulunmaması için, 'catch ()' bloğu yerine bulunan
        // bu blok içinde hatalar yakalanır.
        (error) => {
          this.setState({
            isLoaded: true,
            error
          });
        }
    )
    switch (window.location.hostname) {
      case "localhost":
        this.setState({ host: "http://localhost" });
        break;
      case "mortgagetest.emlakkatilim.com.tr":
        this.setState({ host: "https://mortgagetest.emlakkatilim.com.tr" });
        break;
      case "www.emlakkatilim.com.tr":
        this.setState({ host: "https://mortgage.emlakkatilim.com.tr" });
        break;
      default:
        this.setState({ host: "https://mortgage.emlakkatilim.com.tr" });
        break;
    }
  }
  render() {
    const { error, isLoaded, items } = this.state;
    const settings = {
      dots: false,
      infinite: true,
      speed: 500,
      lazyLoad: false,
      centerMode: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      responsive: [
        {
          breakpoint: 1690,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            dots: true
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            dots: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            dots: true
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true
          }
        }
      ]
    };
    if (error) {
      return <div>Error: {error.message}</div>;
    } else if (!isLoaded) {
      return <Loading />;
    } else {
      return (
        <>
          <MetaTags>
            <title>Neden Biz? | Emlak Katılım Mortgage</title>
            <meta name="robots" content="all" />
            <meta name="description" content="Türkiye Emlak Katılım Bankası A.Ş. Emlak Katılım, 4603 Sayılı Kanun Kapsamında Kurulmuş Kamu Sermayeli Bir Katılım Bankasıdır." />
            <meta property="og:title" content="Neden Biz? | Emlak Katılım Mortgage" />
            <meta property="og:type" content="website" />
            <meta property="og:url" content={`${this.state.host}${this.props.location.pathname}`} />
            <meta property="og:image" content={`${this.state.host}/content/images/seo/emlak-logo-facebook-size.jpg`} />
            <meta property="og:image:width" content="1200" />
            <meta property="og:image:height" content="630" />
            <meta property="og:description" content="Türkiye Emlak Katılım Bankası A.Ş. Emlak Katılım, 4603 Sayılı Kanun Kapsamında Kurulmuş Kamu Sermayeli Bir Katılım Bankasıdır." />
            <meta property="twitter:card" content="summary" />
            <meta property="twitter:site" content="@tremlakkatilim" />
            <meta property="twitter:title" content="Neden Biz? | Emlak Katılım Mortgage" />
            <meta property="twitter:url" content={`${this.state.host}${this.props.location.pathname}`} />
            <meta property="twitter:image" content={`${this.state.host}/content/images/seo/emlak-logo-twitter-size.jpg`} />
            <meta property="twitter:description" content="Türkiye Emlak Katılım Bankası A.Ş. Emlak Katılım, 4603 Sayılı Kanun Kapsamında Kurulmuş Kamu Sermayeli Bir Katılım Bankasıdır." />
          </MetaTags>
          <ContentStyles>
            <Jumbotron className="subpageHeader" fluid>
              <Fade>
                <Container>
                  <h1>TÜRKİYE EMLAK KATILIM BANKASI</h1>
                  <Breadcrumb>
                    <Breadcrumb.Item href="/">Ana Sayfa</Breadcrumb.Item>
                    <Breadcrumb.Item active>Neden Biz?</Breadcrumb.Item>
                  </Breadcrumb>
                </Container>
              </Fade>
            </Jumbotron>
            <Container>
              <Row>
                <Col className="subpageContent" sm={9}>
                  <Fade bottom cascade>
                    <Image className="mb-3" src="/content/images/shutterstock_441508093.png" alt="Ev Resmi" fluid />
                    <h2>TÜRKİYE EMLAK KATILIM BANKASI</h2>
                    <p>Milli mücadele yıllarının ardından, genç Türkiye Cumhuriyeti’nin imarını üstlenmek, inşaat teşebbüslerine destek olmak, yetimlerin hakkını korumak ve gerekli kredileri sağlamak amacıyla 1926 yılında Mustafa Kemal Atatürk’ün imzasıyla Emlak ve Eytam Bankası adıyla kuruldu.</p>
                    <p> Kuruluşunun ilk yıllarında aralarında Yeni Meclis binası, Türk Ocağı binası ve Merkez Bankası binası gibi Birinci Ulusal Mimarlık Dönemi’nin en seçkin örnekleri arasında gösterilen projeleri üstlendi. Ülkemizin ilk konut projesi Bahçelievler Konutları’nın yapımını gerçekleştiren banka, bu projede kullandığı sistemle konut kredisi finansman modelinin ilk örneğini de ortaya koymuş oldu. Daha sonra yurdun dört bir yanında hayata geçirilen Saracoğlu Mahallesi, Levent Konutları, Koşuyolu Mahallesi ve diğer sembol yapılarla ülkenin imarına ve istihdama büyük katkı sağladı.</p>
                    <p> Yıllar içerisinde değişen ülke ihtiyaçları sebebiyle birçok kez isim değişikliğine giden banka, Emlak ve Eytam Bankası olarak çıktığı yola, sırasıyla Türkiye Emlak Kredi Bankası, Tek Bank ve son olarak Türkiye Emlak Bankası isimleriyle devam etti.</p>
                    <p> Bugün Türkiye’nin en genç katılım bankası olarak BDDK’dan faaliyet iznini alan Türkiye Emlak Katılım Bankası, 93 yıllık tecrübesi ve Türkiye’nin alanında en deneyimli bankacılarından oluşan ekibiyle Türkiye’nin gücüne güç katmak için yeniden açıldı.</p>
                    <p> Türkiye Emlak Katılım Bankası, başta inşaat sektörü olmak üzere ekonomik büyüme ve istihdama katkısı yüksek olan stratejik sektörlere yönelik olarak, üreticilerden tüketicilere uzanan ekonomik döngüde sürdürülebilir ve herkes için erişilebilir finansman modelleri geliştirecektir.</p>
                    <ul>
                      <li>Mortgage ile ilgili tüm bilgilere burada</li>
                      <li>Geniş ürün yelpazesi</li>
                      <li>En kolay ve en hızlı başvuru ve finansman kullanımı</li>
                      <li>Uygun finansman oranları</li>
                      <li>120 aya varan vade seçenekleri</li>
                      <li>Kişiye özel ödeme planları</li>
                      <li>Konutunuza güvenilir ve doğru ekspertiz</li>
                      <li>Türkiye’nin önde gelen konut projeleri</li>
                    </ul>
                  </Fade>
                  <h3 className="mt-4 pt-4">MEDYA’DAN HABERLER</h3>
                  <section className="MedyadanHaberler mb-5 pb-5">
                    <Fade bottom cascade>
                      <Slider {...settings}>
                        {
                          items.filter(items => items.isActive === true).map((haberler, i) => {
                            return (
                              <Card data-index={i} key={i}>
                                <a className="imageContainer" target="_blank" rel="noreferrer" href={haberler.link}>
                                  <Card.Img src={`${haberler.picture}`} alt={haberler.title} />
                                </a>
                                <Card.Body>
                                  <Card.Title className="mt-3">{haberler.title}</Card.Title>
                                  <Card.Text>{haberler.source}</Card.Text>
                                  <Button target="_blank" rel="noreferrer" href={haberler.link} variant="outline-primary">Habere Git</Button>
                                </Card.Body>
                              </Card>
                            );
                          })
                        }
                      </Slider>
                    </Fade>
                  </section>
                </Col>
                <Col sm={3}>
                  <Sidebar />
                </Col>
              </Row>
            </Container>
          </ContentStyles>
        </>
      );
    }
  }
}

export default Whyus;